module.exports = __webpack_public_path__ + "static/media/Alain.d81ec6a7.png";